"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDisclose = void 0;
var _react = require("react");
const useDisclose = ({
  open: openProp,
  defaultOpen
} = {}) => {
  const [isOpen, setIsOpen] = (0, _react.useState)(defaultOpen ?? false);
  const open = openProp ?? isOpen;
  const onOpen = (0, _react.useCallback)(() => {
    setIsOpen(true);
  }, []);
  const onClose = (0, _react.useCallback)(() => {
    setIsOpen(false);
  }, []);
  const onToggle = (0, _react.useCallback)(() => {
    setIsOpen(prev => !prev);
  }, []);
  return {
    open,
    onOpen,
    onClose,
    onToggle
  };
};
exports.useDisclose = useDisclose;
